export default {
	"AdditionalPageTypes": true,
	"Admin": true,
	"Advertising": true,
	"AggregatedContentFeed": false,
	"AllowCustomFields": false,
	"AppConfig": true,
	"AppEcommerceManager": true,
	"AppScorePredictor": false,
	"AppSocialManager": true,
	"AppTicketingManager": true,
	"BreakingNews": false,
	"BuildManager": true,
	"Calendar": false,
	"CustomCommentary": true,
	"CustomLineups": true,
	"CustomTables": true,
	"CustomTags": false,
	"Dashboard": true,
	"Fixtures": true,
	"Forms": true,
	"HomepageManager": true,
	"HomepageNewsPromo": true,
	"HomepagePlayerHighlight": false,
	"Lab": false,
	"MatchdayTakeover": true,
	"Media": true,
	"News": true,
	"OptaIntegration": true,
	"Organisations": false,
	"OverlayPromos": true,
	"Pages": true,
	"PlatformOptions": true,
	"PlayerVoting": true,
	"PreventEntitlementEmails": false,
	"Profile": true,
	"RelatedContentTagging": true,
	"RewardsManager": false,
	"RewardPoints": false,
	"Rover": false,
	"Settings": false,
	"SiteConfig": true,
	"Sponsors": true,
	"Squads": true,
	"SsoUsers": true,
	"StreamAMGIntegration": true,
	"Streamline": false,
	"StreamlineAdverts": false,
	"TeamCrestManager": true,
	"Videos": false,
	"Voice": false,
	"WebStats": true
}
